module.exports = __webpack_public_path__ + "static/img/avatar.e5f4f714.png";